module.exports = __webpack_public_path__ + "img/banner-01.a38c740a.jpg";